import HeaderBack from "@/components/fragments/HeaderBack";
import CustomerForm from "@/features/Customer/components/Form";
import { getStoredUserData } from "@/utils/getStoredUser";

export default function CustomerAdd() {
  const userData = getStoredUserData();
  let email = userData?.email || "";
  return (
    <div className="md:w-[80vw] lg:w-[70vw] mx-auto h-screen">
      <HeaderBack text="Tambah Customer" url="/customer" />
      <CustomerForm id={""} email={email} />
    </div>
  );
}
